
import actions from "./actions"
import mutations from "./mutations"

export default  {
    namespaced: true,
    state: () => ({ 
        layout: 'app',
        isShowAddOrUpdateModal: false,

        redeemsStatusList: [
            {id: 1, "name": "Pending"},
            {id: 2, "name": "In Progress"},
            {id: 3, "name": "Approve"},
            {id: 4, "name": "Cancel"},
          ],
        redeemsList: [],
        tableColumns: ['id','points', 'comment','Admin Response','status', 'date', 'action'],
        adminTableColumns: ['id','name','points', 'User Notes', 'Comment','status', 'date', 'action'],
     }),

    mutations: mutations,
    actions: actions,
    getters: { 
        isShowModal(state) {
            return state.isShowAddOrUpdateModal;
        },
     }
  }
